<script>
  import {
    datagridStore,
    datagridFilterStore,
    datagridHistoryStore,
  } from "../../../stores/datagrid.store";
  import { hooksStore } from "../../../stores/hooks.store";

  import {
    vratKodFarbyPodlaTypu,
    vratKodIkonkyPodlaTypu,
  } from "../../../helpers/config";
  import Icon from "../../../components/Icon/Icon.svelte";
  import {
    historyBack,
    historyForward,
    tableHeaderTabClick,
    search,
    tableHeaderBreadcrumbsClick,
    ziskajExportDat,
    tlacTabulku,
    ziskajLvExport,
    filterDg,
  } from "./datagrid.func";
  import { vratSubor } from "../../../api/file";
  import { onDestroy } from "svelte";
  import get from "get-value";

  let searchInput = "";
  let data = [];
  let unsubscribeDatagridStore = datagridStore.subscribe((store) => {
    data = get(store) || {};
  });
  let rozhodnutie_neexistuje_info = false;

  onDestroy(unsubscribeDatagridStore);

  let filter = {};
  let unsubscribeDatagridFilterStore = datagridFilterStore.subscribe(
    (store) => {
      filter = get(store) || {};
      searchInput = filter.post.search;
    }
  );

  onDestroy(unsubscribeDatagridFilterStore);

  let history = {};
  let unsubscribeDatagridHistoryStore = datagridHistoryStore.subscribe(
    (store) => {
      history = get(store) || {};
    }
  );

  onDestroy(unsubscribeDatagridHistoryStore);

  function zavriTabulku() {
    hooksStore.doAction("skryDatagrid");
  }

  let timer;

  const debounce = (v) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      search(v);
    }, 750);
  };

  let searchFormVisible = false;
  function showSearchForm() {
    searchFormVisible = !searchFormVisible;
    if (searchFormVisible) {
      setTimeout(() => {
        document.querySelector("#searchInput").focus();
      }, 100);
    }
  }

  async function getFile(url, filename) {
    await vratSubor(url, filename);
  }

  let filterShow = false;
  function filterShowHide() {
    filterShow = !filterShow;
  }

  import moment from "moment";

  let formDg;
  function filtruj_dg() {
    const formData = new FormData(formDg);
    const data = {};
    for (let field of formData) {
      const [key, value] = field;
      if (key.includes("[")) {
        const k = key.slice(0, -2);
        if (data[k] === undefined) {
          data[k] = [];
        }
        if (k.startsWith("d_") && value !== "") {
          const d = new Date(value);
          const date = moment(d);
          data[k].push(date.format("YYYY-MM-DD"));
        } else {
          data[k].push(value);
        }
      } else {
        data[key] = value;
      }
    }

    filterDg(data);
  }

  import { DateInput } from "date-picker-svelte";

  let locale = {
    weekdays: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
    months: [
      "Január",
      "Február",
      "Marec",
      "Apríl",
      "Máj",
      "Jún",
      "Júl",
      "August",
      "September",
      "Október",
      "November",
      "December",
    ],
  };

  let dateInputs = {
    d_rozhod_od: null,
    d_rozhod_do: null,
    d_uzatvor_od: null,
    d_uzatvor_do: null,
  };
</script>

<!-- Splitter header start  -->
<div class="splitter__header">
  {#if get(data, "allTabs")}
    <ul class="splitter__tab">
      {#each data.allTabs as tab, i}
        <li
          class:show={tab.hover}
          class="color__bg--{vratKodFarbyPodlaTypu(
            tab.name
          )} tooltip {tab.name === filter.get.tab ? 'active' : ''}"
          on:click={() =>
            tableHeaderTabClick({
              id: filter.get.id,
              type: filter.get.type,
              tab: tab.name,
              layer: filter.post.layer,
            })}
          on:mouseenter={() => (tab.hover = true)}
          on:mouseleave={() => (tab.hover = false)}
        >
          <span class="title color__text--{vratKodFarbyPodlaTypu(tab.name)}"
            >{tab.title || tab.name}</span
          >
          {#if tab.count}
            <span
              class="splitter__tab-count color__bg--{vratKodFarbyPodlaTypu(
                tab.name
              )}">{tab.count}</span
            >
          {/if}
          <Icon
            kod={vratKodIkonkyPodlaTypu(tab.name)}
            svg-color-class="color__text--{vratKodFarbyPodlaTypu(tab.name)}"
          />
        </li>
      {/each}
    </ul>
  {/if}

  <ul class="splitter__tab brCount">
    <li class="splitter__records">
      {#if get(data, "header")}
        <div class="splitter__records-street">
          {#each data.header.reverse() as link, i}
            <span
              class="color__text--{vratKodFarbyPodlaTypu(link.typ)}"
              on:click={() =>
                tableHeaderBreadcrumbsClick(
                  hooksStore.applyFilters("resetniANastavFilter", {
                    id: link.id,
                    type: link.typ,
                    tab: "default",
                  })
                )}
              >{link.nazov}
              {#if i < data.header.length - 1} → {/if}
            </span>
          {/each}
        </div>
      {/if}
    </li>
    <li>
      {#if get(data, "recordsTotal")}
        <div class="splitter__records-count">
          Záznamov: <strong>{get(data, "recordsTotal.count", 0)}</strong>
        </div>
      {/if}
    </li>
    {#if get(data, "download") && get(data, "type") !== "rozhodnutia"}
      <li
        on:click={getFile(
          get(data, "download.file"),
          get(data, "download.title")
        )}
      >
        <Icon
          kod={vratKodIkonkyPodlaTypu(get(data, "download.type"))}
          svg-color-class="color__text--{vratKodFarbyPodlaTypu(
            get(data, 'download.type')
          )}"
        />
      </li>
    {/if}
    {#if get(data, "type") === "rozhodnutia"}
      <li
        on:click={get(data, "download")
          ? getFile(get(data, "download.file"), get(data, "download.title"))
          : false}
        class:deactivate={get(data, "download", false) === false}
        class:show={rozhodnutie_neexistuje_info}
        on:mouseenter={() => (rozhodnutie_neexistuje_info = true)}
        on:mouseleave={() => (rozhodnutie_neexistuje_info = false)}
      >
        {#if get(data, "download", false) === false}
          <span class="title">Rozhodnutie nie je k dispozícii.</span>
        {/if}
        <Icon
          kod={vratKodIkonkyPodlaTypu("rozhodnutia")}
          svg-color-class="color__text--{vratKodFarbyPodlaTypu('rozhodnutia')}"
        />
      </li>
    {/if}
    {#if get(data, "type") === "lv"}
      <li on:click={() => ziskajLvExport(data.header[0].id)}>
        <Icon
          kod={vratKodIkonkyPodlaTypu("lv")}
          svg-color-class="color__text--{vratKodFarbyPodlaTypu('lv')}"
        />
      </li>
    {/if}
  </ul>

  <ul class="splitter__tab splitter__tab--controllers">
    <li>
      <span on:click={showSearchForm}>
        <Icon kod="002" />
      </span>

      <div class="input__group input__group--search" class:searchFormVisible>
        <div class="searchForm">
          <button
            type="submit"
            class="input__icon"
            on:click={() => {
              debounce("");
              searchInput = "";
              searchFormVisible = false;
            }}
          >
            <!-- JSON icon search start  -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              viewBox="0 0 329.27 329.263"
            >
              <g transform="translate(0 -0.135)">
                <path
                  d="M21.34,329.4A21.332,21.332,0,0,1,6.258,292.984L292.848,6.39a21.329,21.329,0,0,1,30.164,30.164L36.422,323.148A21.231,21.231,0,0,1,21.34,329.4Zm0,0"
                  fill="currentColor"
                />
                <path
                  d="M307.93,329.4a21.273,21.273,0,0,1-15.082-6.25L6.258,36.554A21.329,21.329,0,0,1,36.422,6.39l286.59,286.594A21.332,21.332,0,0,1,307.93,329.4Zm0,0"
                  fill="currentColor"
                />
              </g>
            </svg>
            <!-- JSON icon search end  -->
          </button>
          <input
            type="text"
            placeholder="Vyhľadať"
            class="input"
            id="searchInput"
            bind:value={searchInput}
            on:keyup={({ target: { value } }) => debounce(value)}
          />
        </div>
      </div>
    </li>
    <li>
      <div class="filterWrap" class:filterShow>
        <div class="nadpis">Filter</div>
        <form
          class="filtre"
          on:submit|preventDefault={filtruj_dg}
          bind:this={formDg}
        >
          <div class="filter">
            <span class="label">&nbsp;</span>
            <input
              type="text"
              size="7"
              value="OD"
              placeholder="OD"
              class="no-border"
              disabled
              readonly
            />
            <input
              type="text"
              size="7"
              value="DO"
              placeholder="DO"
              class="no-border"
              disabled
              readonly
            />
          </div>
          <div class="filter">
            <span class="label">Priznaný úver</span>
            <input
              type="text"
              value=""
              name="prizn_uver[]"
              size="7"
              placeholder="0"
            />
            <input
              type="text"
              value=""
              name="prizn_uver[]"
              size="7"
              placeholder="123456"
            />
          </div>
          <div class="filter">
            <span class="label">Celkový úver</span>
            <input
              type="text"
              value=""
              name="celk_uver[]"
              size="7"
              placeholder="0"
            />
            <input
              type="text"
              value=""
              name="celk_uver[]"
              size="7"
              placeholder="123456"
            />
          </div>
          <div class="filter">
            <span class="label">Dátum rozhodnutia</span>
            <div class="datepicker">
              <DateInput
                bind:value={dateInputs.d_rozhod_od}
                format="dd.MM.yyyy"
                {locale}
                max={new Date(2025, 11, 31, 23, 59, 59, 999)}
                min={new Date(2018, 0, 1, 0, 0, 0, 0)}
                placeholder=""
                closeOnSelection={true}
              />
              <input
                type="hidden"
                name="d_rozhod[]"
                bind:value={dateInputs.d_rozhod_od}
              />
            </div>
            <div class="datepicker">
              <DateInput
                bind:value={dateInputs.d_rozhod_do}
                format="dd.MM.yyyy"
                {locale}
                max={new Date(2025, 11, 31, 23, 59, 59, 999)}
                min={new Date(2018, 0, 1, 0, 0, 0, 0)}
                placeholder=""
                closeOnSelection={true}
              />
              <input
                type="hidden"
                name="d_rozhod[]"
                bind:value={dateInputs.d_rozhod_do}
              />
            </div>
          </div>
          <div class="filter">
            <span class="label">Dátum uzatvorenia</span>
            <div class="datepicker">
              <DateInput
                bind:value={dateInputs.d_uzatvor_od}
                format="dd.MM.yyyy"
                {locale}
                max={new Date(2025, 11, 31, 23, 59, 59, 999)}
                min={new Date(2018, 0, 1, 0, 0, 0, 0)}
                placeholder=""
                closeOnSelection={true}
              />
              <input
                type="hidden"
                name="d_uzatvor[]"
                bind:value={dateInputs.d_uzatvor_od}
              />
            </div>
            <div class="datepicker">
              <DateInput
                bind:value={dateInputs.d_uzatvor_do}
                format="dd.MM.yyyy"
                {locale}
                max={new Date(2025, 11, 31, 23, 59, 59, 999)}
                min={new Date(2018, 0, 1, 0, 0, 0, 0)}
                placeholder=""
                closeOnSelection={true}
              />
              <input
                type="hidden"
                name="d_uzatvor[]"
                bind:value={dateInputs.d_uzatvor_do}
              />
            </div>
          </div>
          <div class="filter">
            <span class="label">Účel</span>
            <select name="ucel">
              <option value="">-</option>
              <option value="301">301</option>
              <option value="303">303</option>
              <option value="411">411</option>
              <option value="413">413</option>
              <option value="443">443</option>
              <option value="611">611</option>
              <option value="613">613</option>
              <option value="643">643</option>
              <option value="803">803</option>
              <option value="893">893</option>
              <option value="3101">3101</option>
              <option value="3103">3103</option>
              <option value="4101">4101</option>
              <option value="4103">4103</option>
              <option value="4201">4201</option>
              <option value="4291">4291</option>
              <option value="4501">4501</option>
              <option value="4503">4503</option>
              <option value="4521">4521</option>
              <option value="4531">4531</option>
              <option value="6101">6101</option>
              <option value="6103">6103</option>
              <option value="6201">6201</option>
              <option value="6291">6291</option>
            </select>
          </div>
          <div class="filter">
            <input
              type="reset"
              value="Zrušiť"
              on:click={() => {
                Object.keys(dateInputs).forEach(
                  (key) => (dateInputs[key] = null)
                );
                setTimeout(() => {
                  filtruj_dg();
                }, 100);
              }}
            />
            <input type="submit" value="Filtrovať" />
          </div>
        </form>
      </div>
      <span on:click={filterShowHide}>
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="512"
          height="512"
          viewBox="0 0 512.000000 512.000000"
          preserveAspectRatio="xMidYMid meet"
          class="icon history {filter.active > 0 ? 'active' : ''}"
        >
          <g
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            stroke="none"
          >
            <path
              d="M0 3985 l0 -285 2560 0 2560 0 0 285 0 285 -2560 0 -2560 0 0 -285z"
            />
            <path
              d="M850 2560 l0 -280 1710 0 1710 0 0 280 0 280 -1710 0 -1710 0 0 -280z"
            />
            <path
              d="M1990 1135 l0 -285 570 0 570 0 0 285 0 285 -570 0 -570 0 0 -285z"
            />
          </g>
        </svg>
      </span>
    </li>
    <li on:click={historyBack}>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96.000000 96.000000"
        class="icon history {history.active > 0 ? 'active' : ''}"
      >
        <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)">
          <path
            d="M235 670 l-130 -130 131 -131 130 -130 25 20 24 20 -95 95 -95 96
                218 0 c199 0 221 -2 257 -20 45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130
                -21 -11 -46 -20 -55 -20 -10 0 -15 -10 -15 -31 0 -31 1 -31 37 -24 52 10 85
                28 121 69 68 78 68 194 -1 273 -59 67 -84 73 -337 73 l-225 0 95 95 c93 93 94
                94 75 115 -10 11 -21 20 -24 20 -4 0 -65 -59 -136 -130z"
          />
        </g>
      </svg>
    </li>
    <li on:click={historyForward}>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96.000000 96.000000"
        class="icon history {history.active < history.data.length - 1
          ? 'active'
          : ''}"
      >
        <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)">
          <path
            d="M565 780 c-19 -21 -18 -22 75 -115 l95 -95 -225 0 c-198 0 -230 -3
              -265 -19 -168 -78 -164 -314 7 -385 59 -25 78 -21 78 14 0 20 -5 30 -15 30 -9
              0 -34 9 -55 20 -45 23 -80 80 -80 130 0 50 35 107 80 130 36 18 58 20 257 20
              l218 0 -95 -96 -95 -95 24 -20 25 -20 130 130 131 131 -130 130 c-71 71 -132
              130 -136 130 -3 0 -14 -9 -24 -20z"
          />
        </g>
      </svg>
    </li>
    <li on:click={() => ziskajExportDat("csv")}>
      <Icon kod="042" />
    </li>
    <li on:click={tlacTabulku}>
      <Icon kod="043" svg-fill="#144672" />
    </li>

    <li on:click={zavriTabulku}>
      <!-- JSON icon Close start -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon"
        viewBox="0 0 329.27 329.263"
      >
        <g transform="translate(0 -0.135)">
          <path
            d="M21.34,329.4A21.332,21.332,0,0,1,6.258,292.984L292.848,6.39a21.329,21.329,0,0,1,30.164,30.164L36.422,323.148A21.231,21.231,0,0,1,21.34,329.4Zm0,0"
            fill="#ff8d8d"
          />
          <path
            d="M307.93,329.4a21.273,21.273,0,0,1-15.082-6.25L6.258,36.554A21.329,21.329,0,0,1,36.422,6.39l286.59,286.594A21.332,21.332,0,0,1,307.93,329.4Zm0,0"
            fill="#ff8d8d"
          />
        </g>
      </svg>
      <!-- JSON icon Close end -->
    </li>
  </ul>
</div>

<!-- Splitter header end  -->
<style lang="scss">
  .icon {
    &.history {
      color: #ccc;

      &.active {
        color: #000;
      }
    }
  }

  .input__group {
    display: none;
    position: absolute;
    right: 0;
    bottom: 35px;
    z-index: 9;
    border: 1px solid #e4e4e4;

    &.searchFormVisible {
      display: block;
    }
  }
  .input__group--search {
    .input {
      border-bottom: none;
    }
  }

  .brCount {
    flex-grow: 1;
    justify-content: space-between;

    li {
      border: none;
    }
  }
  .title {
    position: absolute;
    background: #f4f4f4;
    padding: 5px 10px 10px;
    width: 160px;
    z-index: 2;
    bottom: 100%;
    left: -1px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: none;
    font-size: 0.7rem;
    line-height: 16px;
    text-align: center;
    display: none;
  }
  li.show .title {
    display: block;
  }
  li:hover:not(.active) {
    background-color: #f4f4f4;
  }

  .filterWrap {
    position: absolute;
    background: #f4f4f4;
    padding: 5px 10px 10px;
    width: auto;
    z-index: 2;
    bottom: 100%;
    right: -1px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: none;
    font-size: 0.7rem;
    line-height: 16px;
    text-align: left;
    display: none;
    min-width: 300px;
  }
  .filterWrap.filterShow {
    display: block;
  }
  .filterWrap .nadpis {
    font-size: var(--text-md);
    margin: 10px 0;
  }
  .filterWrap .filtre .filter {
    display: flex;
    justify-content: right;
    align-items: center;
    margin-bottom: 5px;
  }

  .filterWrap .filtre .filter .label {
    margin-right: auto;
    font-size: var(--text-xs);
    white-space: nowrap;
  }

  .no-border {
    border: none;
  }
</style>
